const cartaDocentePayment = (state = false, action) => {
    switch(action.type) {
        case 'cartaDocentePayment':
            return action.payload;
        default:
            return state;
    }
}

export default cartaDocentePayment;